var BlockLibrary = (function($) {

  var _s = {
    scrollSpyNav: '.js-scrollSpyNav',
    scrollSpyNavItem: '.js-scrollSpyNav li a'
  };

  var _init = function() {
    _bindEvents();

  };

  var _bindEvents = function() {
    // Gather All Sections
    let scrollSpyItems = [];
    $(_s.scrollSpyNavItem).each(function(i) {
      scrollSpyItems.push($(this).attr('href'));
    });

    // Scroll Event
    $(window).on("scroll", function () {
      let pos = $(document).scrollTop();
  
      $.each(scrollSpyItems, function(key, val) {
        let itemPos = $(val).offset().top - 101;
        let nextItemPos = ($(scrollSpyItems[key+1]).length > 0) ?
          $(scrollSpyItems[key+1]).offset().top - 101
          : itemPos + $(val).outerHeight();

        if ( pos >= itemPos && pos < nextItemPos ) {
          $(_s.scrollSpyNavItem).removeClass('active');
          $(_s.scrollSpyNavItem+'[href="'+val+'"').addClass('active');
        }
      });
  
    });
    $(window).trigger('scroll');
  
  };

  return {
    init: _init
  };

})(jQuery);